import React from "react";
import DotLegalDeleteDialogWrapper from "@common/components/dotLegalDeleteDialog/DotLegalDeleteDialogWrapper";
import { useProcessDocumentDeleteDialog } from "./ProcessDocumentDeleteDialog.hooks";
import { ProcessDocument } from "../ProcessDocument.types";

export interface IProcessDocumentDeleteDialogProps {
    onCloseDialog: () => void;
    onDeletedDocument: () => void;
    selectedDocument: ProcessDocument;
    processId: string;
}

function ProcessDocumentDeleteDialog(props: IProcessDocumentDeleteDialogProps) {
    const { deleteDocumentClick, inProgress } = useProcessDocumentDeleteDialog(props);
    return (
        <DotLegalDeleteDialogWrapper
            open
            itemForDeletion={props.selectedDocument!.name}
            onDialogClose={props.onCloseDialog}
            onOkClick={() => deleteDocumentClick(props.selectedDocument!.documentId)}
            inProgress={inProgress}
        />
    );
}

export default ProcessDocumentDeleteDialog;
